import {useEffect, useRef} from "react"
import mapboxgl from "mapbox-gl"
import "mapbox-gl/dist/mapbox-gl.css"

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN

type Props = {
    geoLocation: {latitude: number; longitude: number}
}

export function UserGeolocationMap({geoLocation}: Props) {
    const mapContainerRef = useRef(null)
    const mapRef = useRef(null)
    const markerRef = useRef(null) // Ref to hold the current marker

    useEffect(() => {
        if (mapRef.current) return

        const map = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: "mapbox://styles/mapbox/streets-v11",
            center: {lat: geoLocation.latitude, lon: geoLocation.longitude},
            zoom: 12
        })

        map.addControl(new mapboxgl.NavigationControl(), "top-right")
        mapRef.current = map

        return () => map.remove()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (!mapRef.current) return

        if (mapRef.current) {
            mapRef.current.flyTo({
                center: {lat: geoLocation.latitude, lon: geoLocation.longitude},
                essential: true
            })
        }
        if (markerRef.current) {
            markerRef.current.remove()
        }
        markerRef.current = new mapboxgl.Marker()
            .setLngLat({lat: geoLocation.latitude, lon: geoLocation.longitude})
            .addTo(mapRef.current)
    }, [geoLocation.latitude, geoLocation.longitude])

    return <div ref={mapContainerRef} style={{width: "100%", height: 500, borderRadius: "8px"}} />
}
